import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { SharedDocumentsService } from '@app/shared/services/shared-documents.service';
import { ICoreAuthorizationDTO, IDocumentResponseDTO, MoveDocument, UploadDocument, UploadFile, UploadLetter } from '@app/core/model';
import { Observable, of, switchMap } from 'rxjs';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class DocumentsPACService extends SharedDocumentsService {

  constructor(
    http: HttpClient,
    shellService: ShellService,
  ) {
    super(http, shellService, ProductNames.PACIM);
  }

  override getFilesMetaData(tenantId: string, authorizationByProductId: string): Observable<IDocumentResponseDTO[]> {
    return this.http.get<IDocumentResponseDTO[]>(`${this.getBaseUrl(tenantId, authorizationByProductId)}/GetFilesMetaData`);
  }

  override moveFiles(tenantId: string, authorization: ICoreAuthorizationDTO, data: MoveDocument[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.getBaseUrl(tenantId, authorization.authorizationId)}/SharedMoveDocuments`, data);
  }

  override getFilesByName(tenantId: string, authorizationNumber: string, documentFileName: string): Observable<IDocumentResponseDTO[]> {
    const encodedFileName = encodeURIComponent(documentFileName);
    return this.http.get<IDocumentResponseDTO[]>(`${this.API_URL}/tenants/${tenantId}/authorizations/${authorizationNumber}/Files/GetFilesByName?documentFileName=${encodedFileName}`);
  }

  override deleteDocumentForMoveDocument(
    tenantId: string,
    authorizationByProductId: string,
    authorizationNumber: string,
    docMetaDataId: string,
    documentFileName: string,
  ): Observable<UploadDocument[]> {
    return this.getFilesMetaData(tenantId, authorizationByProductId)
      .pipe(switchMap(res => {
        const documentId: string = res.find(elem => elem.documentFileName === documentFileName)?.docMetaDataId;

        if (documentId) {
          return this.http.delete<UploadDocument[]>(`${this.getBaseUrl(tenantId, authorizationByProductId)}/DeleteDocument/${documentId}`);
        } else {
          return of();
        }
      }));
  }

  override uploadFile(tenantId: string, authorizationByProductId: string, data: UploadFile[], isWidgetUpload = false): Observable<UploadFile[]> {
    data?.forEach(it => it.isFromCreateAuth = false);
    const options = isWidgetUpload ? { params: new HttpParams().set('isWidgetUpload', isWidgetUpload) } : {};
    return this.http.post<UploadFile[]>(`${this.getBaseUrl(tenantId, authorizationByProductId)}`, data, options);
  }

  override uploadLetter(tenantId: string, authorization: ICoreAuthorizationDTO, data: UploadLetter): Observable<UploadLetter> {
   if(data.documentType === "Detailed Explanation of Non-Coverage"){
       data.documentType = 'DENC'
   }
    // Passing isUrgent as a query param to reuse BaseFileDTO in the BE instead of creating a new one.
    return this.http.post<UploadLetter>(`${this.getBaseUrl(tenantId, authorization.authorizationId)}/UploadLetterTranslation?isUrgent=${data.isUrgent}`, data);
  }
}
